/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ViewerPageModel } from './ViewerPageModel';
import {
    ViewerPageModelFromJSON,
    ViewerPageModelFromJSONTyped,
    ViewerPageModelToJSON,
} from './ViewerPageModel';

/**
 * ビューア用ページリスト取得APIレスポンスモデル
 * @export
 * @interface ViewerPagesResponseModel
 */
export interface ViewerPagesResponseModel {
    /**
     * 総ページ数
     * @type {number}
     * @memberof ViewerPagesResponseModel
     */
    totalPages: number;
    /**
     * スクロールの向き
     * @type {string}
     * @memberof ViewerPagesResponseModel
     */
    scrollDirection: string;
    /**
     * 見開き指定, 1 : 右ページ, 2 : 左ページ
     * 開始のページの位置。 左ページ（LEFT）から始まる場合「片起こし」、右ページ（RIGHT）から始まる場合「見開き」となります。
     * @type {number}
     * @memberof ViewerPagesResponseModel
     */
    spreadDesignation: number;
    /**
     * 
     * @type {Array<ViewerPageModel>}
     * @memberof ViewerPagesResponseModel
     */
    result?: Array<ViewerPageModel>;
}

/**
 * Check if a given object implements the ViewerPagesResponseModel interface.
 */
export function instanceOfViewerPagesResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalPages" in value;
    isInstance = isInstance && "scrollDirection" in value;
    isInstance = isInstance && "spreadDesignation" in value;

    return isInstance;
}

export function ViewerPagesResponseModelFromJSON(json: any): ViewerPagesResponseModel {
    return ViewerPagesResponseModelFromJSONTyped(json, false);
}

export function ViewerPagesResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewerPagesResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPages': json['totalPages'],
        'scrollDirection': json['scrollDirection'],
        'spreadDesignation': json['spreadDesignation'],
        'result': !exists(json, 'result') ? undefined : ((json['result'] as Array<any>).map(ViewerPageModelFromJSON)),
    };
}

export function ViewerPagesResponseModelToJSON(value?: ViewerPagesResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPages': value.totalPages,
        'scrollDirection': value.scrollDirection,
        'spreadDesignation': value.spreadDesignation,
        'result': value.result === undefined ? undefined : ((value.result as Array<any>).map(ViewerPageModelToJSON)),
    };
}

